import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import { FaChevronRight, FaTimes } from 'react-icons/fa';

import * as styles from './BlexiaTopBar.module.scss';
import { useTranslation } from 'react-i18next';
import { HIDDEN_FEATURES } from '../constants';

export const query = graphql`
  fragment BlexiaTopBar on SanityBlexiaHomepageTopBar {
    text
  }
`;

export interface BlexiaTopBarProps {
  text: string;
}

const BlexiaTopBar = ({ text }: BlexiaTopBarProps): React.ReactElement => {
  const { t } = useTranslation();

  const showCloseBtn = !HIDDEN_FEATURES.includes('hide_blexia_top_bar_close_btn');

  const [hidden, setHidden] = useState(showCloseBtn);

  useEffect(() => {
    if (localStorage.getItem('BlexiaBarVisible') === null) {
      setHidden(false);
    }
  }, []);

  return (
    <div className={styles.blexiaTopBar + (hidden ? ' ' + styles.hidden : '')}>
      <div className={styles.barText}>
        <p>{text}</p>
        <a href="/blexia">
          {t('blexia.button_label', 'Know More')} {<FaChevronRight fontSize="8px" />}
        </a>
      </div>

      {showCloseBtn && (
        <FaTimes
          className={styles.icon}
          onClick={() => {
            localStorage.setItem('BlexiaBarVisible', 'false');
            setHidden(true);
          }}
        />
      )}
    </div>
  );
};
export default BlexiaTopBar;
